import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'CERCA TRA LE VERIFICHE INVALSI',
        description: 'Trovi le verifiche INVALSI ufficiali. Raffina la tua ricerca con gli altri filtri.',
        name: 'InvalsiNavItem',
        tutorialName: 'verifica_tab-INVALSI'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: -5,
        yOffset: 0
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: -5,
        yOffset: 0
    }
};
